export const PageTitle = (title) => {
    let defaultTitle = "Craft Your Taste";
    return document.title = `${title} - ${defaultTitle}`;
}